var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonPulldown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#404040;stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_\\u30B9_100",
    className: "cls-1",
    d: "m1.51,3.21c0-.58.21-1.14.61-1.57.74-.81,2-.87,2.81-.13.05.04.09.09.13.13l7.49,7.99,7.4-7.9c.74-.81,2-.87,2.81-.13.05.04.09.09.13.13.81.89.81,2.25,0,3.14l-8.87,9.47c-.74.81-2,.87-2.81.13-.05-.04-.09-.09-.13-.13L2.12,4.78c-.39-.43-.61-.99-.6-1.57h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPulldown);
export default __webpack_public_path__ + "static/media/button_pulldown.0f6ce8f17e788fdd7e585abe73f0c67a.svg";
export { ForwardRef as ReactComponent };